@let freight = freightDetail();
@if (freight.status !== EFreightStatus.DEFAULT) {
  <div class="bar-steps-indicator">
    @for (stop of freight.stopsDetailed; track stop.id) {
      <button
        (click)="goToDetailStop(stop.id)"
        [class.to-load]="stop.id === freight.nextStopId && stop.type === EStopType.LOAD"
        [class.to-unload]="stop.id === freight.nextStopId && stop.type === EStopType.UNLOAD"
        [class.to-unload_load]="stop.id === freight.nextStopId && stop.type === EStopType.UNLOAD_LOAD"
      >
        {{ stop.position + 1 }}
      </button>
    }
    <div class="line"></div>
  </div>

  <lib-message-ui-ionic [messages]="messages"></lib-message-ui-ionic>

  <!-- The missing-vehicles banner only applies while the freight is assigned or on route; the red
       label of the assigned vehicles section keeps showing for every status (different UX contexts). -->
  @if (isMissingVehicles() && isAssignedOrOnRouteStatus()) {
    <ion-list class="block-content-round notice-no-vehicles">
      <ion-item-group>
        <ion-item-divider sticky>
          <ion-icon
            slot="start"
            aria-hidden="true"
            src="../assets/material-symbols/notification_important_24dp.svg"
          ></ion-icon>
          <p class="subtitle">{{ 'freight.no_vehicles' | translate }}</p>
        </ion-item-divider>

        <p class="ion-padding-horizontal fs-sm">
          <strong>{{ 'freight.detail.missing_vehicles_notice' | translate }}</strong>
        </p>

        @if (canManageVehicles()) {
          <div class="ion-text-center">
            <lib-freight-carrier-assignation-button
              [freight]="freightBasic()"
              [mode]="freight.vehicles.length ? 'modify' : 'assign'"
            ></lib-freight-carrier-assignation-button>
          </div>
        }
      </ion-item-group>
    </ion-list>
  }

  @if (freight.status === EFreightStatus.FINISHED && freight.hasPendingDoc === true) {
    <ion-list class="block-content-round notice-delivery-note">
      <ion-item-group>
        <ion-item-divider sticky>
          <ion-icon
            slot="start"
            aria-hidden="true"
            src="../assets/material-symbols/notification_important_24dp.svg"
          ></ion-icon>
          <p class="subtitle">{{ 'freight.general.documentation' | translate }}</p>
        </ion-item-divider>

        <p>
          <strong>{{ 'freight.general.missing_dn' | translate }}</strong>
        </p>

        <lib-file-drop-area
          [acceptFormats]="'image/jpeg,application/pdf'"
          [disabled]="itemVM().actionsDisabled"
          (fileToParentComponent)="uploadDigitizedDeliveryNote($event)"
        ></lib-file-drop-area>
      </ion-item-group>
    </ion-list>
  }

  <ion-list class="block-content-round">
    <ion-item-group>
      <ion-item-divider sticky>
        <div>
          <p class="subtitle">{{ 'freight.detail.general_data' | translate }}</p>
        </div>
      </ion-item-divider>

      <div class="freight">
        <ion-grid class="ion-no-padding">
          <ion-row>
            <ion-col
              size="12"
              size-lg="6"
            >
              <div
                class="freight-data-block status"
                [class.assigned]="freight.status === EFreightStatus.ASSIGNED"
                [class.on-route]="freight.status === EFreightStatus.ON_ROUTE"
                [class.finished]="freight.status === EFreightStatus.FINISHED"
                [class.cancelled]="freight.status === EFreightStatus.CANCELLED"
              >
                @if (freight.status === EFreightStatus.ASSIGNED) {
                  <ion-icon
                    aria-hidden="true"
                    src="../assets/material-symbols/play_circle_24dp.svg"
                  ></ion-icon>
                }
                @if (freight.status === EFreightStatus.ON_ROUTE) {
                  <ion-icon
                    aria-hidden="true"
                    src="../assets/material-symbols/arrow_circle_right_24dp.svg"
                  ></ion-icon>
                }
                @if (freight.status === EFreightStatus.FINISHED) {
                  <ion-icon
                    aria-hidden="true"
                    src="../assets/material-symbols/task_alt_24dp.svg"
                  ></ion-icon>
                }
                @if (freight.status === EFreightStatus.CANCELLED) {
                  <ion-icon
                    aria-hidden="true"
                    src="../assets/material-symbols/cancel_24dp.svg"
                  ></ion-icon>
                }
                <div>
                  <p>
                    <strong>{{ 'freight.detail.status.' + freight.status | translate }}</strong>
                  </p>
                </div>
              </div>
            </ion-col>
            <ion-col
              size="12"
              size-lg="6"
            >
              <div class="freight-data-block">
                <ion-icon
                  aria-hidden="true"
                  src="../assets/material-symbols/barcode_24dp.svg"
                ></ion-icon>
                <div>
                  <p class="subtitle">{{ 'freight.detail.okcargo_reference' | translate }}</p>
                  <p>{{ freight.reference }}</p>
                </div>
              </div>
            </ion-col>
            <ion-col
              size="12"
              size-lg="6"
            >
              <div class="freight-data-block">
                <ion-icon
                  aria-hidden="true"
                  src="../assets/material-symbols/local_shipping_24dp.svg"
                ></ion-icon>
                <div>
                  <p class="subtitle">{{ 'freight.detail.vehicle_type' | translate }}</p>
                  <p>
                    @for (vehicleType of freight.vehicleTypes; track $index) {
                      <strong>{{ 'vehicleType.' + vehicleType | translate }}</strong>
                      ,
                    }
                    @for (loadingType of freight.loadingTypes; track $index; let count = $count) {
                      @if ($index < count - 1) {
                        {{ 'freight.detail.loading_type.' + loadingType | translate | lowercase }},
                      } @else {
                        {{ 'freight.detail.loading_type.' + loadingType | translate | lowercase }}
                      }
                    }
                  </p>
                </div>
              </div>
            </ion-col>

            <ion-col
              size="12"
              size-lg="6"
            >
              <div class="freight-data-block">
                <ion-icon
                  aria-hidden="true"
                  src="../assets/material-symbols/okc_assigned_vehicle_24dp.svg"
                ></ion-icon>
                <div>
                  <p class="subtitle">{{ 'freight.detail.asigned_vehicle' | translate }}</p>
                  <div class="driver-vehicles">
                    @for (vehicle of freight.vehicles; track vehicle.id) {
                      <p>
                        <span class="plate">{{ vehicle.plate }}</span>
                        @if (vehicle.type) {
                          {{ 'vehicleType.' + vehicle.type | translate }}
                        }
                      </p>
                    } @empty {
                      @if (isMissingVehicles()) {
                        <strong class="fs-sm">
                          <ion-text color="danger">{{ 'freight.no_vehicles' | translate }}</ion-text>
                        </strong>
                      }
                    }
                    @if (canManageVehicles()) {
                      <lib-freight-carrier-assignation-button
                        [freight]="freightBasic()"
                        [mode]="freight.vehicles.length ? 'modify' : 'assign'"
                      ></lib-freight-carrier-assignation-button>
                    }
                  </div>
                </div>
              </div>
            </ion-col>

            @if (freight.instructions && freight.observations) {
              <ion-col
                size="12"
                size-lg="6"
              >
                <div class="freight-data-block">
                  <ion-icon
                    aria-hidden="true"
                    src="../assets/material-symbols/info_24dp.svg"
                  ></ion-icon>
                  <div>
                    <p class="subtitle">{{ 'freight.detail.instructions' | translate }}</p>
                    @if (freight.instructions) {
                      <p>{{ freight.instructions }}</p>
                    }
                    @if (freight.observations) {
                      <p>{{ freight.observations }}</p>
                    }
                  </div>
                </div>
              </ion-col>
            }

            @if (canViewPrices() && freight.price) {
              <ion-col
                size="12"
                size-lg="6"
              >
                <div class="freight-data-block">
                  <ion-icon
                    aria-hidden="true"
                    src="../assets/material-symbols/payments_24dp.svg"
                  ></ion-icon>
                  <div>
                    <p class="subtitle">{{ 'freight.detail.price' | translate }}</p>
                    <p>{{ freight.price | number: '1.2-2' }} €</p>
                  </div>
                </div>
              </ion-col>

              <!-- TODO simplify this, move to ts-->
              @if (
                freight.status === EFreightStatus.FINISHED &&
                priceWithDiscount() &&
                ((freight.billingStatus === EInvoiceStatus.READY_TO_INVOICE &&
                  (freight.fastPaymentForCarrierStatus === EFastPaymentForCarrierStatus.AVAILABLE ||
                    freight.fastPaymentForCarrierStatus === EFastPaymentForCarrierStatus.REJECTED ||
                    freight.fastPaymentForCarrierStatus === EFastPaymentForCarrierStatus.REQUESTED ||
                    freight.fastPaymentForCarrierStatus === EFastPaymentForCarrierStatus.APPROVED)) ||
                  (freight.billingStatus !== EInvoiceStatus.READY_TO_INVOICE &&
                    freight.fastPaymentForCarrierStatus === EFastPaymentForCarrierStatus.APPROVED))
              ) {
                <ion-col
                  size="12"
                  size-lg="6"
                >
                  <div class="freight-data-block">
                    <ion-icon
                      aria-hidden="true"
                      src="../assets/material-symbols/okc_fast_payment_24dp.svg"
                    ></ion-icon>
                    <div>
                      @if (priceWithDiscount()) {
                        @if (freight.billingStatus === EInvoiceStatus.READY_TO_INVOICE) {
                          @if (freight.fastPaymentForCarrierStatus === EFastPaymentForCarrierStatus.AVAILABLE) {
                            <p class="subtitle">Pronto pago disponible</p>
                            <p class="fs-xs">
                              La factura aún no se ha emitido. Puedes solicitar el pronto pago. Recibirás
                              {{ priceWithDiscount() | number: '1.2-2' }}&nbsp;€ en 24&nbsp;h desde la aprobación de la
                              solicitud.
                            </p>
                            <ion-button
                              size="small"
                              (click)="showFastpayRequestModal()"
                            >
                              {{ 'fast_pay.view_conditions_and_request' | translate }}
                            </ion-button>
                          } @else if (freight.fastPaymentForCarrierStatus === EFastPaymentForCarrierStatus.REJECTED) {
                            <p class="subtitle">Pronto pago rechazado</p>
                            <p class="fs-xs">
                              Lo sentimos, la documentación aportada no es correcta. Contacta con nosotros para
                              cualquier aclaración.
                            </p>
                            <lib-incidence-button [reference]="freightBasic().reference"></lib-incidence-button>
                          } @else if (freight.fastPaymentForCarrierStatus === EFastPaymentForCarrierStatus.REQUESTED) {
                            <p class="subtitle">Pronto pago solicitado</p>
                            <p class="fs-xs">
                              Has solicitado el pronto pago de
                              {{ priceWithDiscount() | number: '1.2-2' }}&nbsp;€. Estamos revisando tu documentación. Si
                              es correcta, recibirás el pago en 24&nbsp;h.
                            </p>
                          } @else if (freight.fastPaymentForCarrierStatus === EFastPaymentForCarrierStatus.APPROVED) {
                            <p class="subtitle">Pronto pago aprobado</p>
                            <p class="fs-xs">
                              En breve se emitirá la factura por un importe de
                              {{ priceWithDiscount() | number: '1.2-2' }}&nbsp;€. Recibirás el pago antes de 24&nbsp;h.
                            </p>
                          }
                        } @else {
                          @if (freight.fastPaymentForCarrierStatus === EFastPaymentForCarrierStatus.APPROVED) {
                            <p class="subtitle">Pronto pago aprobado</p>
                            <p class="fs-xs">
                              Este servicio se ha facturado con la opción de pronto pago por un importe de
                              {{ priceWithDiscount() | number: '1.2-2' }}&nbsp;€.
                            </p>
                          }
                        }
                      }
                    </div>
                  </div>
                </ion-col>
              }
            }

            @if (canViewMileages() && (freight.loadedKm || freight.emptyKm || freight.detourKm)) {
              <ion-col
                size="12"
                size-lg="6"
              >
                <div class="freight-data-block">
                  <ion-icon
                    aria-hidden="true"
                    src="../assets/material-symbols/route_24dp.svg"
                  ></ion-icon>
                  <div>
                    <p class="subtitle">{{ 'freight.detail.mileages' | translate }}</p>
                    <ion-grid>
                      @if (freight.loadedKm !== undefined) {
                        <ion-row>
                          <ion-col>{{ 'freight.detail.load_mileage' | translate }}</ion-col>
                          <ion-col class="ion-text-end">
                            {{ freight.loadedKm | number: '1.2-2' }} km
                            @if (canViewPrices() && freight.loadedPerKmPrice !== undefined) {
                              ({{ freight.loadedPerKmPrice * freight.loadedKm | number: '1.2-2' }} €)
                            }
                          </ion-col>
                        </ion-row>
                      }
                      @if (freight.emptyKm !== undefined) {
                        <ion-row>
                          <ion-col>{{ 'freight.detail.empty_mileage' | translate }}</ion-col>
                          <ion-col class="ion-text-end">
                            {{ freight.emptyKm | number: '1.2-2' }} km
                            @if (canViewPrices() && freight.emptyPerKmPrice !== undefined) {
                              ({{ freight.emptyPerKmPrice * freight.emptyKm | number: '1.2-2' }} €)
                            }
                          </ion-col>
                        </ion-row>
                      }
                      @if (freight.detourKm !== undefined) {
                        <ion-row>
                          <ion-col>{{ 'freight.detail.detour_mileage' | translate }}</ion-col>
                          <ion-col class="ion-text-end">
                            {{ freight.detourKm | number: '1.2-2' }} km
                            @if (canViewPrices() && freight.detourPerKmPrice !== undefined) {
                              ({{ freight.detourPerKmPrice * freight.detourKm | number: '1.2-2' }} €)
                            }
                          </ion-col>
                        </ion-row>
                      }
                    </ion-grid>
                  </div>
                </div>
              </ion-col>
            }

            @if (canViewDrivers()) {
              <ion-col
                size="12"
                size-lg="6"
              >
                <div class="freight-data-block">
                  <ion-icon
                    aria-hidden="true"
                    src="../assets/material-symbols/id_card_24dp.svg"
                  ></ion-icon>
                  <div>
                    <p class="subtitle">Conductor</p>
                    <div class="driver-vehicles">
                      @for (driver of freight.drivers; track driver.id) {
                        <p>{{ driver.name }}</p>
                      } @empty {
                        <span class="fs-sm">Sin asignar</span>
                      }
                      @if (canModifyDriver()) {
                        <lib-freight-carrier-assignation-button
                          [freight]="freightBasic()"
                          [mode]="freight.drivers.length ? 'modify' : 'assign'"
                        ></lib-freight-carrier-assignation-button>
                      }
                    </div>
                  </div>
                </div>
              </ion-col>
            }

            @if (freight.digitizedDeliveryNotes.length > 0) {
              <ion-col
                size="12"
                size-lg="6"
              >
                <div class="freight-data-block">
                  <ion-icon
                    aria-hidden="true"
                    src="../assets/material-symbols/file_copy_24dp.svg"
                  ></ion-icon>
                  <div>
                    <p class="subtitle">{{ 'freight.detail.digitized_delivery_notes' | translate }}</p>

                    <ion-list lines="full">
                      @for (deliveryNote of freight.digitizedDeliveryNotes; track deliveryNote.id) {
                        <ion-item
                          button
                          detail="true"
                          detail-icon="../assets/material-symbols/visibility_24dp.svg"
                          (click)="downloadDocument(deliveryNote.url, deliveryNote.name)"
                          target="_blank"
                          [disabled]="itemVM().actionsDisabled"
                        >
                          <ion-label>{{ deliveryNote.name }}</ion-label>
                        </ion-item>
                      }
                    </ion-list>
                  </div>
                </div>

                @if (freight.status === EFreightStatus.FINISHED) {
                  <lib-file-drop-area
                    [acceptFormats]="'image/jpeg,application/pdf'"
                    [disabled]="itemVM().actionsDisabled"
                    (fileToParentComponent)="uploadDigitizedDeliveryNote($event)"
                  ></lib-file-drop-area>
                }
              </ion-col>
            }
          </ion-row>
        </ion-grid>
      </div>
    </ion-item-group>
  </ion-list>

  @if (
    canViewPrices() &&
    freight.status === EFreightStatus.FINISHED &&
    freight.billingStatus === EInvoiceStatus.READY_TO_INVOICE &&
    freight.fastPaymentForCarrierStatus === EFastPaymentForCarrierStatus.AVAILABLE &&
    freight.price
  ) {
    <lib-fastpay-freight-card-cta
      [originalPrice]="freight.price"
      [freightId]="freight.id"
      [hasEnoughDocs]="!freight.hasPendingDoc"
      (showModalFastPayment)="showFastpayRequestModal()"
    ></lib-fastpay-freight-card-cta>
  }

  @for (stop of freight.stopsDetailed; track stop.id) {
    <ion-list
      [id]="stop.id"
      class="block-content-round"
      [class.--to-load]="stop.type === EStopType.LOAD"
      [class.--to-unload]="stop.type === EStopType.UNLOAD"
      [class.--to-unload_load]="stop.type === EStopType.UNLOAD_LOAD"
      [class.--active]="freight.nextStopId === stop.id && stop.status !== EStopStatus.FINISHED"
    >
      <ion-item-group>
        <ion-item-divider sticky>
          <div>
            <span class="step-number">{{ stop.position + 1 }}</span>
            <p class="subtitle">
              @if (stop.type === EStopType.LOAD) {
                {{ 'freight.detail.load' | translate }}
              } @else if (stop.type === EStopType.UNLOAD) {
                {{ 'freight.detail.unload' | translate }}
              } @else if (stop.type === EStopType.UNLOAD_LOAD) {
                {{ 'freight.detail.unload_load' | translate }}
              }
            </p>
          </div>
          @if (stop.type === EStopType.LOAD) {
            <ion-icon
              slot="end"
              aria-hidden="true"
              src="../assets/material-symbols/upload_24dp.svg"
            ></ion-icon>
          } @else if (stop.type === EStopType.UNLOAD) {
            <ion-icon
              slot="end"
              aria-hidden="true"
              src="../assets/material-symbols/download_24dp.svg"
            ></ion-icon>
          } @else if (stop.type === EStopType.UNLOAD_LOAD) {
            <ion-icon
              slot="end"
              aria-hidden="true"
              src="../assets/material-symbols/swap_vert_24dp.svg"
            ></ion-icon>
          }
        </ion-item-divider>

        <div class="freight">
          <ion-grid class="ion-no-padding">
            @if (freight.nextStopId === stop.id && stop.status !== EStopStatus.FINISHED) {
              <ion-row class="ion-padding-bottom">
                <ion-col
                  size="12"
                  size-lg="6"
                >
                  <div class="freight-data-block">
                    <ion-icon
                      aria-hidden="true"
                      src="../assets/material-symbols/file_copy_24dp.svg"
                    ></ion-icon>
                    <div>
                      <p class="subtitle">{{ 'freight.detail.upload_digitized_delivery_notes' | translate }}</p>
                      <lib-file-drop-area
                        [acceptFormats]="'image/jpeg,application/pdf'"
                        [disabled]="itemVM().actionsDisabled"
                        (fileToParentComponent)="uploadDigitizedDeliveryNote($event)"
                      ></lib-file-drop-area>
                    </div>
                  </div>
                </ion-col>

                <ion-col
                  size="12"
                  size-lg="6"
                >
                  <div class="freight-data-block">
                    <ion-icon
                      aria-hidden="true"
                      src="../assets/material-symbols/play_circle_24dp.svg"
                    ></ion-icon>
                    <div>
                      <p class="subtitle">{{ 'freight.detail.modify_stop_status' | translate }}</p>
                      <lib-freight-carrier-stop-button [freight]="freightBasic()"></lib-freight-carrier-stop-button>
                    </div>
                  </div>
                </ion-col>
              </ion-row>
            }

            <ion-row>
              <ion-col
                size="12"
                size-lg="6"
              >
                <!-- TODO move to component? -->

                <div class="freight-data-block">
                  <ion-icon
                    aria-hidden="true"
                    src="../assets/material-symbols/pin_drop_24dp.svg"
                  ></ion-icon>

                  <div>
                    <p class="fs-sm">
                      {{ stop.address.company }}
                    </p>
                    <p>{{ stop.address.street }}</p>
                    @if (stop.address.extraLine) {
                      <p>{{ stop.address.extraLine }}</p>
                    }
                    <p>{{ stop.address.postalCode }} {{ stop.address.city }}</p>
                    <p class="ion-text-uppercase">
                      <strong>
                        ({{ 'countries.' + stop.address.countryCode | translate }})
                        {{ 'states.' + stop.address.countryCode + stop.address.stateCode | translate }}
                      </strong>
                    </p>
                    @if (stop.address.coords) {
                      <ion-button
                        fill="outline"
                        color="primary"
                        size="small"
                        (click)="openMap(stop.address.coords)"
                      >
                        <ion-icon
                          aria-hidden="true"
                          slot="start"
                          src="../assets/material-symbols/map_24dp.svg"
                        ></ion-icon>
                        {{ 'freight.detail.map' | translate }}
                      </ion-button>
                    }
                  </div>
                </div>

                @if (stop.arrivalDriverAppPoint) {
                  <div class="freight-data-block">
                    <ion-icon
                      aria-hidden="true"
                      src="../assets/material-symbols/where_to_vote_24dp.svg"
                    ></ion-icon>
                    <div>
                      <p class="subtitle">{{ 'freight.detail.coords_app' | translate }}</p>
                      <p class="fs-sm">
                        {{ stop.arrivalDriverAppPoint.latitude }}, {{ stop.arrivalDriverAppPoint.longitude }}
                      </p>
                    </div>
                  </div>
                }

                <div class="freight-data-block">
                  <ion-icon
                    aria-hidden="true"
                    src="../assets/material-symbols/schedule_24dp.svg"
                  ></ion-icon>

                  <div>
                    <p class="subtitle">{{ 'freight.detail.schedule' | translate }}:</p>

                    <ion-grid>
                      <ion-row>
                        <ion-col>{{ 'freight.detail.expected_arrival' | translate }}:</ion-col>
                        <ion-col class="ion-text-end">{{ stop.since | dfnsFormat: 'ccc Pp' }}&nbsp;h</ion-col>
                      </ion-row>
                      <ion-row>
                        <ion-col>{{ 'freight.detail.expected_departure' | translate }}:</ion-col>
                        <ion-col class="ion-text-end">{{ stop.until | dfnsFormat: 'ccc Pp' }}&nbsp;h</ion-col>
                      </ion-row>
                    </ion-grid>
                  </div>
                </div>

                @if (stop.arrivedAt || stop.departedAt) {
                  <div class="freight-data-block">
                    <ion-icon
                      aria-hidden="true"
                      src="../assets/material-symbols/schedule_24dp.svg"
                    ></ion-icon>

                    <div>
                      <p class="subtitle">{{ 'freight.detail.realized_schedule' | translate }}:</p>
                      <ion-grid>
                        @if (stop.arrivedAt) {
                          <ion-row>
                            <ion-col>
                              <strong>{{ 'freight.detail.arrival_at_stop' | translate }}:</strong>
                            </ion-col>
                            <ion-col class="ion-text-end fw-700">
                              {{ stop.arrivedAt | dfnsFormat: 'ccc Pp' }}&nbsp;h
                            </ion-col>
                          </ion-row>
                        }
                        @if (stop.departedAt) {
                          <ion-row>
                            <ion-col>
                              <strong>{{ 'freight.detail.stop_departure' | translate }}:</strong>
                            </ion-col>
                            <ion-col class="ion-text-end fw-700">
                              {{ stop.departedAt | dfnsFormat: 'ccc Pp' }}&nbsp;h
                            </ion-col>
                          </ion-row>
                        }
                      </ion-grid>
                    </div>
                  </div>
                }
              </ion-col>
              <ion-col
                size="12"
                size-lg="6"
              >
                @if (stop.reference !== undefined) {
                  <div class="freight-data-block">
                    <ion-icon
                      aria-hidden="true"
                      src="../assets/material-symbols/barcode_24dp.svg"
                    ></ion-icon>
                    <div>
                      <p class="subtitle">{{ 'freight.detail.stop_reference' | translate }}</p>
                      <p class="fs-sm">{{ stop.reference }}</p>
                    </div>
                  </div>
                }

                @if (
                  stop.unloadedPackages !== undefined ||
                  stop.netWeight !== undefined ||
                  stop.packages !== undefined ||
                  stop.unloadedNetWeight !== undefined ||
                  stop.unloadedPackages !== undefined ||
                  stop.goodsDescription !== undefined
                ) {
                  <div class="freight-data-block">
                    <ion-icon
                      aria-hidden="true"
                      src="../assets/material-symbols/summarize_24dp.svg"
                    ></ion-icon>
                    <div>
                      <p class="subtitle">{{ 'freight.detail.shipment_data' | translate }}</p>
                      <ion-grid>
                        @if (stop.netWeight !== undefined) {
                          <ion-row>
                            <ion-col>{{ 'freight.detail.weight' | translate }}</ion-col>
                            <ion-col class="ion-text-end">{{ stop.netWeight }} kg</ion-col>
                          </ion-row>
                        }
                        @if (stop.packages !== undefined) {
                          <ion-row>
                            <ion-col>{{ 'freight.detail.packages' | translate }}</ion-col>
                            <ion-col class="ion-text-end">{{ stop.packages }}</ion-col>
                          </ion-row>
                        }
                        @if (stop.unloadedNetWeight !== undefined) {
                          <ion-row>
                            <ion-col>{{ 'freight.detail.unloaded_weight' | translate }}</ion-col>
                            <ion-col class="ion-text-end">{{ stop.unloadedNetWeight }}</ion-col>
                          </ion-row>
                        }
                        @if (stop.unloadedPackages !== undefined) {
                          <ion-row>
                            <ion-col>{{ 'freight.detail.unloaded_packages' | translate }}</ion-col>
                            <ion-col class="ion-text-end">{{ stop.unloadedPackages }}</ion-col>
                          </ion-row>
                        }
                        @if (stop.goodsDescription !== undefined) {
                          <ion-row>
                            <ion-col>{{ 'freight.detail.goods' | translate }}</ion-col>
                            <ion-col class="ion-text-end">{{ stop.goodsDescription }}</ion-col>
                          </ion-row>
                        }
                      </ion-grid>
                    </div>
                  </div>
                }

                @if (stop.instructions !== undefined && stop.instructions !== '') {
                  <div class="freight-data-block">
                    <ion-icon
                      aria-hidden="true"
                      src="../assets/material-symbols/comment_24dp.svg"
                    ></ion-icon>
                    <div>
                      <p class="subtitle">{{ 'freight.detail.instructions' | translate }}</p>
                      <p>{{ stop.instructions }}</p>
                    </div>
                  </div>
                }

                @if (stop.reservations !== undefined && stop.reservations !== '') {
                  <div class="freight-data-block">
                    <ion-icon
                      aria-hidden="true"
                      src="../assets/material-symbols/comment_24dp.svg"
                    ></ion-icon>
                    <div>
                      <p class="subtitle">{{ 'freight.detail.noted_reservations' | translate }}</p>
                      <p>{{ stop.reservations }}</p>
                    </div>
                  </div>
                }
              </ion-col>
            </ion-row>
          </ion-grid>

          <!-- TODO implement documents? -->
        </div>
      </ion-item-group>
    </ion-list>
  }
} @else {
  <lib-skeleton-card-two-columns></lib-skeleton-card-two-columns>
  <lib-spinner-loading></lib-spinner-loading>
  <lib-skeleton-card-generic></lib-skeleton-card-generic>
}
